export default __webpack_public_path__ + "static/SalesONT-3ff6a74e20e060bb19a7d55fe9f2d525.png";